// extracted by mini-css-extract-plugin
export default {"navIcon":"BurgerIcon_navIcon__ppU4E","open":"BurgerIcon_open__rcOWZ"};